import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { MoreHorizontal, Search, KeyRound, Ban, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function Parents() {
    const [q, setQ] = useState("");
    const [rows, setRows] = useState([]);

    const load = async () => {
        try { const { data } = await api.get("/admin/parents", { params: q ? { q } : {} }); setRows(data); }
        catch (e) { toast.error(formatApiError(e)); }
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

    const resetPw = async (userId) => {
        try {
            const { data } = await api.post(`/admin/users/${userId}/reset-password`, {});
            toast.success(`تمت الإعادة. كلمة المرور: ${data.new_password}`);
        } catch (e) { toast.error(formatApiError(e)); }
    };
    const toggle = async (userId) => {
        try { await api.post(`/admin/users/${userId}/toggle-active`); toast.success("تم التحديث"); load(); }
        catch (e) { toast.error(formatApiError(e)); }
    };

    return (
        <div className="space-y-5">
            <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                    <h1 className="text-2xl font-bold text-[#0F172A]">حسابات أولياء الأمور</h1>
                    <p className="text-sm text-slate-500 mt-1">{rows.length} حساب</p>
                </div>
                <div className="flex items-center gap-2">
                    <div className="relative">
                        <Search className="w-4 h-4 text-slate-400 absolute right-3 top-1/2 -translate-y-1/2" />
                        <Input data-testid="parents-search-input" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="بحث..." className="pr-10 w-80" />
                    </div>
                    <Button variant="outline" onClick={load}>تحديث</Button>
                </div>
            </div>

            <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-testid="parents-data-table">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-slate-50 text-slate-600 text-xs uppercase tracking-wide">
                            <tr>
                                <th className="px-4 py-3 text-right font-semibold">اسم الطالبة</th>
                                <th className="px-4 py-3 text-right font-semibold">الفصل</th>
                                <th className="px-4 py-3 text-right font-semibold">اسم مستخدم ولي الأمر</th>
                                <th className="px-4 py-3 text-right font-semibold">الحالة</th>
                                <th className="px-4 py-3 text-right font-semibold">آخر دخول</th>
                                <th className="px-4 py-3 w-16"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length === 0 && <tr><td colSpan={6} className="text-center py-12 text-slate-400">لا توجد حسابات — أنشئي حسابات من استيراد Excel</td></tr>}
                            {rows.map((r) => (
                                <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50/60">
                                    <td className="px-4 py-3 font-medium text-[#0F172A]">{r.student_name || "—"}</td>
                                    <td className="px-4 py-3 text-slate-600">{r.student_class}</td>
                                    <td className="px-4 py-3 font-mono-num text-slate-700" dir="ltr">{r.username}</td>
                                    <td className="px-4 py-3">
                                        {r.active ? <Badge className="bg-emerald-100 text-emerald-800 hover:bg-emerald-100">نشط</Badge> : <Badge className="bg-red-100 text-red-800 hover:bg-red-100">موقوف</Badge>}
                                    </td>
                                    <td className="px-4 py-3 text-xs text-slate-500 font-mono-num" dir="ltr">{r.last_login_at ? new Date(r.last_login_at).toLocaleString("ar-EG") : "—"}</td>
                                    <td className="px-4 py-3">
                                        <DropdownMenu>
                                            <DropdownMenuTrigger asChild><Button variant="ghost" size="icon" data-testid={`parent-row-menu-${r.id}`}><MoreHorizontal className="w-4 h-4" /></Button></DropdownMenuTrigger>
                                            <DropdownMenuContent align="start">
                                                <DropdownMenuItem onClick={() => resetPw(r.id)}><KeyRound className="w-4 h-4 ml-2" /> إعادة تعيين كلمة المرور</DropdownMenuItem>
                                                <DropdownMenuSeparator />
                                                <DropdownMenuItem onClick={() => toggle(r.id)}>
                                                    {r.active ? <><Ban className="w-4 h-4 ml-2" /> إيقاف</> : <><CheckCircle2 className="w-4 h-4 ml-2" /> تفعيل</>}
                                                </DropdownMenuItem>
                                            </DropdownMenuContent>
                                        </DropdownMenu>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
